/**
 * Returns the first argument it receives.
 *
 * @internal
 */
export function identityFunc(x) {
  return x;
}
